import {routes} from '../../../../routing/routes';
import SubmitButton from '../../common/components/SubmitButton';
import useForgot from './useForgot';
import {useI18n} from '../../../../common/providers/I18nProvider';
import Form from '../../common/components/Form';
import RightAlignedLink from '../../common/components/RightAlignedLink';
import FormControl from '../../common/components/FormControl';
import EmailField from '../../common/components/EmailField';

export default function Forgot() {
	const {loading, formik, canNotSubmit, isEmailInvalid} = useForgot();
	const {i18n} = useI18n();

	return (
		<Form
			title='AUTH.FORGOT.TITLE'
			subtitle='AUTH.FORGOT.SUBTITLE'
			handleSubmit={formik.handleSubmit}
			status={formik.status}
		>
			<FormControl label='AUTH.FORGOT.FIELD.EMAIL.LABEL' isInvalid={isEmailInvalid} error={formik.errors.email}>
				<EmailField
					fieldProps={formik.getFieldProps('email')}
					isInvalid={isEmailInvalid}
					placeholder='AUTH.FORGOT.FIELD.EMAIL.PLACEHOLDER'
				/>
			</FormControl>

			<RightAlignedLink title='AUTH.FORGOT.BUTTON.LOGIN' route={routes.login} />

			<SubmitButton canNotSubmit={canNotSubmit} loading={loading}>
				{i18n('AUTH.FORGOT.BUTTON.SEND')}
			</SubmitButton>
		</Form>
	);
}
